import axios from "axios";
import { API_BASE_URL, FETCH_LIMIT } from "../../globalVars";

export default {
  namespaced: true,

  actions: {
    async hydrate({ commit }) {
      const store = this;
      const last = this.getters["entities/settings/query"]().first()
        .lastUpdateFromServer;
      await fetchNext({
        store: store,
        offset: 0,
        lastDateTime: last
      });
    }
  }
};

async function fetchNext({ store, offset, lastDateTime = 0 }) {
  try {
    let response = await axios({
      method: "get",
      url:
        API_BASE_URL +
        `/biz-review-history?createdAt[$gt]=${new Date(
          lastDateTime
        ).toISOString()}&$limit=${FETCH_LIMIT}&$skip=${offset}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      }
    });
    const obj = response.data.data;
    const maxRows = response.data.total;
    let bizReviewHistories = [];
    obj.forEach(function(bizReviewHistory) {
      bizReviewHistories.push({
        id: bizReviewHistory.id,
        isDirty: false,
        bizReviewTypeId: bizReviewHistory.bizReviewTypeId,
        reviewCount: bizReviewHistory.reviewCount,
        reviewAvg: bizReviewHistory.reviewAvg,
        // googleReviewCount: bizReviewHistory.googleReviewCount,
        // googleReviewAvg: bizReviewHistory.googleReviewAvg,
        // facebookReviewCount: bizReviewHistory.facebookReviewCount,
        // facebookReviewAvg: bizReviewHistory.facebookReviewAvg,
        // yelpReviewCount: bizReviewHistory.yelpReviewCount,
        // yelpReviewAvg: bizReviewHistory.yelpReviewAvg,
        createdAt: Date.parse(bizReviewHistory.createdAt)
      });
    });
    if (bizReviewHistories.length > 0) {
      store.dispatch("entities/bizReviewHistories/insertOrUpdate", {
        data: bizReviewHistories
      });
    }
    store.dispatch("entities/settings/setIsOffline", false);
    if (maxRows > FETCH_LIMIT + offset) {
      await fetchNext({
        store,
        offset: FETCH_LIMIT + offset,
        lastDateTime
      });
    }
  } catch (error) {
    store.dispatch("entities/settings/setIsOffline", true);
  }
}
